import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/comics';

export default function BrandSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start gap-12">
          {/* Left text */}
          <div className="lg:w-1/2">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium mb-6">
              关于韩漫网
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-6">
              打造最纯粹的
              <br />
              免费韩漫阅读平台
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              {siteInfo.description}
            </p>

            <div className="flex items-center gap-8 mt-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">{siteInfo.totalComics}</div>
                <div className="text-xs text-foreground-500 mt-1">收录漫画</div>
              </div>
              <div className="w-px h-12 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">{siteInfo.totalUsers}</div>
                <div className="text-xs text-foreground-500 mt-1">注册用户</div>
              </div>
              <div className="w-px h-12 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">{siteInfo.dailyVisits}</div>
                <div className="text-xs text-foreground-500 mt-1">日访问量</div>
              </div>
            </div>
          </div>

          {/* Right images */}
          <div className="lg:w-1/2 w-full">
            <div className="flex gap-4">
              <div className="w-[40%] aspect-[3/4] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20reading%20atmosphere%20with%20warm%20natural%20light%20soft%20cream%20background%20minimal%20aesthetic%20cozy%20interior%20with%20books%20and%20plants%20Korean%20style%20clean%20composition%20harmonious%20colors&width=600&height=800&seq=brand-img-01&orientation=portrait"
                  alt="韩漫网阅读体验"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-[60%] aspect-[3/4] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Digital%20tablet%20displaying%20colorful%20webtoon%20comic%20art%20on%20a%20clean%20wooden%20desk%20with%20warm%20ambient%20lighting%20cozy%20modern%20interior%20Korean%20aesthetic%20minimal%20design%20soft%20shadows&width=800&height=1067&seq=brand-img-02&orientation=portrait"
                  alt="韩漫网在线阅读"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
          >
            了解更多关于我们
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}